import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import { payloadToQueryParamsUrl } from '@/_shared/helpers/payloadToQueryParamsUrl';
import { GenericGet } from '@/_shared/types/swagger';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_YEAR_YEAR_QUARTER_QUARTER_PATH_KEY,
} from '@/swagger/constants/credits-keys';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_USERID_ACTIVATION_EMAIL_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_USERID_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_GUEST_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_PATH_KEY,
} from '@/swagger/constants/slash-keys';

type QueryParameters = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_PATH_KEY
>['request']['query'];

export const API_GET_DELEGATES = (org: string, queryParams: QueryParameters) => {
  const baseUrl = buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_PATH_KEY,
    {
      organizationId: org,
    },
  );
  return payloadToQueryParamsUrl(queryParams, baseUrl);
};

export const API_CREATE_DELEGATE_GUEST = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_GUEST_PATH_KEY, {
    organizationId: org,
  });
};

export const API_CREATE_DELEGATE_EMPLOYER = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_PATH_KEY, {
    organizationId: org,
  });
};

export const API_DELETE_DELEGATE = (org: string, userId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_USERID_PATH_KEY, {
    organizationId: org,
    userId,
  });
};

export const API_POST_DELEGATE_ACTIVATION_EMAIL = (org: string, userId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_USERID_ACTIVATION_EMAIL_PATH_KEY,
    {
      organizationId: org,
      userId,
    },
  );
};

export const API_GET_ORGANIZATION_CREDITS_QUARTER = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_PATH_KEY, {
    organizationId: org,
  });
};

export const API_GET_ORGANIZATION_CREDITS = (org: string, year: number, quarter: number) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_YEAR_YEAR_QUARTER_QUARTER_PATH_KEY,
    {
      organizationId: org,
      year,
      quarter,
    },
  );
};
